module.exports = "/images/ch.svg?a49cb0de3c2945beceeb439ab47a5a0c";